const isPrivateMode = () =>
    // eslint-disable-next-line no-undef
    new Promise((resolve) => {
        const yes = () => resolve(true);
        const not = () => resolve(false);
        // eslint-disable-next-line no-undef
        if (indexedDB == null) yes();
        else {
            // eslint-disable-next-line no-undef
            const db = indexedDB.open('inPrivate');
            db.onsuccess = not;
            db.onerror = yes;
        }
    });

const isAdBlockInactive = () =>
    // eslint-disable-next-line no-undef
    new Promise((resolve) => {
        const time = Date.now();
        // eslint-disable-next-line no-undef
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => {
            if (Date.now() - time < 50) resolve(false);
            else resolve(true);
        };
        img.src = '//www.facebook.com/tr/';
    });

const canRunAdsFirefox = () =>
    // eslint-disable-next-line no-undef
    new Promise((resolve) => {
        // eslint-disable-next-line no-undef
        if ('MozAppearance' in document.documentElement.style) {
            isPrivateMode().then((isPrivateMode) => {
                if (isPrivateMode) resolve(false);
                else
                    isAdBlockInactive().then((isAdBlockInactive) => {
                        if (isAdBlockInactive) resolve(true);
                        else resolve(false);
                    });
            });
        } else resolve(true);
    });

export { canRunAdsFirefox };
